import { Injectable } from '@angular/core';
import { Guid } from '@models/guid';
import { CStampUnitActivity } from '@models/imported/SagaSchema/CStampUnitActivity';
import { List } from '@models/list';
import { CacheService, CacheState } from '@services/cache/cache.service';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';

@Injectable()
export class LastDestinationService {
  private stampUnitActivites: List<CStampUnitActivity> = null;

  private readonly _current = new BehaviorSubject<CStampUnitActivity>(null);
  get $current(): Observable<CStampUnitActivity> {
    return this._current.asObservable();
  }

  private myCallcardId: Guid = null;

  constructor(private myUnit: MyUnitService, private cache: CacheService) {}

  setup() {
    this.cache.state
      .pipe(
        filter(cacheState => cacheState === CacheState.ready),
        first()
      )
      .subscribe(() => this.onCacheReady());
  }

  private onCacheReady() {
    this.stampUnitActivites = this.cache.getListOf<CStampUnitActivity>(CStampUnitActivity);

    this.stampUnitActivites.addFilter(stampUnitActivity => this.myUnit.myCardId === stampUnitActivity.CallCardId);
    this.stampUnitActivites.addSort((a, b) => b.CreatedUTC.getTime() - a.CreatedUTC.getTime());

    this.setSelectedDestination();

    this.stampUnitActivites.onRefresh.subscribe(() => this.setSelectedDestination());
    this.myUnit.$change.pipe(filter(() => this.myCallcardId !== this.myUnit.myCardId)).subscribe(() => this.onCallcardChanged());
  }

  private setSelectedDestination() {
    const selectedDestination = this.stampUnitActivites.items.find(item => item.Text && item.Text !== '');
    this._current.next(selectedDestination ? selectedDestination : null);
  }

  private onCallcardChanged() {
    const callcardId = (this.myUnit && this.myUnit.myCardId) || null;
    if (callcardId !== null && callcardId !== this.myCallcardId) {
      this.myCallcardId = callcardId;
      this.stampUnitActivites.refresh();
    }
  }
}
